// `action.proposed.presentation`; only PANEL opens the widget's card
const aiAssistantPresentations = {
    BACKGROUND: 'BACKGROUND',
    PANEL: 'PANEL',
    PAGE: 'PAGE',
};

export default aiAssistantPresentations;
